import redirectInterceptor from "@/interceptors/redirect_interceptor";

export default class VesselInformationService {
  constructor(baseUrl, vesselPositionMapper) {
    this.baseUrl = baseUrl;
    this.vesselPositionMapper = vesselPositionMapper;
  }

  async getVoyageVesselPosition(vesselName, startDate, endDate) {
    try {
      const response = await redirectInterceptor.get(`${this.baseUrl}/vesselInformation/${vesselName}/voyageNoonAtSeaData`, {
        params: {
          startDate,
          endDate
        },
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      });
      return response.data.map(this.vesselPositionMapper);
    } catch (error) {
      throw error;
    }
  }
}
